import React, { useState, useEffect } from "react";
import axios from "axios";
import { Alert } from "antd";
import { Link, useNavigate } from "react-router-dom";
import AdminHeader from "../AdminHeader";
import AdminFooter from "../AdminFooter";
export const AdminSupervisorList = () => {
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [gdata, getData] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isClickedclient, setIsClickedclient] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showAlerts, setShowAlerts] = useState(false);
  const handlegetClient = (clientId, index) => {
    let formdata = {
      id: clientId,
    };
    setActiveIndex(index);
    axios
      .post(
        "https://jlmining.app/api/adminsupervisor/getlistsupervisor",
        formdata,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        getData(res.data.row[0]);
        setIsClicked(true);
      })
      .catch((err) => {
        //console.log(err.response.data);
      });
  };
  const handleuserRemove = (clientid) => {
    console.log(clientid);
    let client_id = {
      id: clientid,
    };
    const del = window.confirm(
      "Are you sure you want to delete this supervisor?"
    );
    if (del) {
      axios
        .post(
          "https://jlmining.app/api/adminsupervisor/deletesup",
          client_id,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          // setIsstaus(true);
          // setNostaus(false);

          if (res.data.status === 1) {
            setShowAlert(true);
            setShowAlert({ type: "error" });
            setIsClicked(false);
            setActiveIndex(null);
          } else {
            setShowAlerts(true);
            setShowAlerts({ type: "errors" });
          }
          getsupervisor();
          setTimeout(() => {
            setShowAlert(false);
          }, 3500);
        })
        .catch((err) => { });
    }
  };
  const handleedit = (event) => {
    setIsClickedclient(!isClickedclient);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    var vll = event.target;
  };
  useEffect(() => {
    //changeFavicon(require("../../assets/admin/images/f-icon.png"));
    document.title = "Supervisor Page";
    const userStr = JSON.parse(localStorage.getItem("admin"));
    if (userStr == null) {
      navigate("/admin/login");
    }
    getsupervisor();
  }, []);
  const getsupervisor = () => {
    let formdata = {};
    axios
      .post("https://jlmining.app/api/adminsupervisor/getlist", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        console.log(res.data);
        setdata(res.data.results);
      })
      .catch((err) => { });
  };
  return (
    <>
      <div>
        <AdminHeader />
        <div className="main-right-body">
          <div className="block-full">
            <div className="row">
              <div className="float-end d-flex justify-content-end">
                <Link to="/admin/supervisor/add" className="addclient">
                  Add
                </Link>
              </div>
            </div>
            <div className="row gy-4">
              <div className="col-lg-4">
                <div className="d-block red-heading bg-white shadow p-4">
                  <h3 className="mb-3">Select Supervisor</h3>
                  <div className="over-empl">
                    <div className="d-flex flex-column h-100 clientselectmain">
                      {Array.isArray(data) && data.length > 0 ? (
                        data.map((item, index) => (
                          <Link
                            to="javascript:void(0)"
                            className={`item ${activeIndex === index ? "active" : ""
                              }`}
                            onClick={() => handlegetClient(item.id, index)}
                          >
                            {item.name}
                          </Link>
                        ))
                      ) : (
                        <Link> No data available </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-8">
                {isClicked && (
                  <div className="right-form-box bg-white shadow p-4">
                    <div className="row gap-2">
                      <div className="col-12 col-lg-6">
                        <div className="d-flex justify-content-between p-2">
                          <label for="">Name:-</label>
                          {gdata && gdata.name && (
                            <span className="fs-14">{gdata.name}</span>
                          )}
                        </div>
                        <div className="d-flex justify-content-between p-2">
                          <label for="">Email-Id:-</label>
                          {gdata && gdata.email && (
                            <span className="fs-14">{gdata.email}</span>
                          )}
                        </div>
                        <div className="d-flex justify-content-between p-2">
                          <label for="">Phone Number:-</label>
                          {gdata && gdata.phone && (
                            <span className="fs-14">{gdata.phone}</span>
                          )}
                        </div>

                        <div className="d-flex justify-content-between p-2">
                          {gdata && gdata.id && (
                            <Link
                              title="Delete"
                              to="javascript:void(0)"
                              className="addclient"
                              onClick={() => handleuserRemove(gdata.id)}
                            >
                              Delete
                            </Link>
                          )}
                          {gdata && gdata.id && (
                            <Link
                              title="Delete"
                              to="javascript:void(0)"
                              className="editclient"
                              onClick={() => handleedit(gdata.id)}
                            >
                              Edit
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {isClickedclient && (
                  <div className="right-form-box bg-white shadow p-4 mt-4">
                    <h4 className="mb-3">Update Client</h4>

                    <form action="" onSubmit={handleSubmit}>
                      <input
                        type="hidden"
                        name="client_id"
                        placeholder="type here"
                        Value={gdata.id}
                      />
                      <div className="row gy-2">
                        <div className="col-12 col-lg-6">
                          <div className="d-flex flex-column gap-2">
                            <label for="">Client Name </label>
                            <input
                              type="text"
                              name="name"
                              placeholder="type here"
                              Value={gdata.name}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-lg-6">
                          <div className="d-flex flex-column gap-2">
                            <label for="">Position </label>
                            <input
                              type="text"
                              name="position"
                              placeholder="type here"
                              Value={gdata.position}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-6">
                          <div className="d-flex flex-column gap-2">
                            <label for="">Department </label>
                            <input
                              type="text"
                              name="department"
                              placeholder="type here"
                              Value={gdata.department}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-6">
                          <div className="d-flex flex-column gap-2">
                            <label for="">Work Phone Number </label>
                            <input
                              type="text"
                              pattern="[0-9]*"
                              minlength="10"
                              name="phone_number"
                              placeholder="type here"
                              Value={gdata.phone_number}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-6">
                          <div className="d-flex flex-column gap-2">
                            <label for="">Mobile Phone Number </label>
                            <input
                              type="text"
                              pattern="[0-9]*"
                              minlength="10"
                              name="mobile_number"
                              placeholder="type here"
                              Value={gdata.mobile_number}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-6">
                          <div className="d-flex flex-column gap-2">
                            <label for="">Emergency Contact Number </label>
                            <input
                              type="text"
                              pattern="[0-9]*"
                              minlength="10"
                              name="home_phone_number"
                              placeholder="type here"
                              Value={gdata.home_phone_number}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-6">
                          <div className="d-flex flex-column gap-2">
                            <label for="">Fax Number </label>
                            <input
                              type="text"
                              name="fax_number"
                              placeholder="type here"
                              Value={gdata.fax_number}
                            />
                          </div>
                        </div>
                        <div className="col-12 col-lg-6">
                          <div className="d-flex flex-column gap-2">
                            <label for="">
                              Email-Id{" "}
                              <span className="text-danger fs-14">*</span>
                            </label>
                            <input
                              type="email"
                              required
                              name="email"
                              placeholder="type here"
                              Value={gdata.email}
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="d-flex align-items-center gap-3 justify-content-end">
                            <button className="sub-btn" type="submit">
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <AdminFooter />
      </div>
    </>
  );
};
